module.exports = __webpack_public_path__ + "static/media/HOD.df7c560e.png";